import axios from "../../axios-instance";

/**
 * Get feature requests for super admin
 * @param {*} options
 */
export const getFeatureRequests = (options) => async (dispatch) => {
  const { data, onSuccess, onError } = options || {};
  axios
    .post("/super-admin/feature-requests", data)
    .then((res) => {
      if (onSuccess) {
        const { data } = res || {};
        onSuccess(data);
      }
    })
    .catch((err) => {
      if (onError) {
        onError(err);
      }
    });
};

/**
 * Get feature request filter metadata
 * @param {*} options
 */
export const getFeatureRequestMeta = (options) => async (dispatch) => {
  const { onSuccess, onError } = options || {};
  axios
    .get("/super-admin/feature-requests/meta")
    .then((res) => {
      if (onSuccess) {
        const { data: resData } = res || {};
        onSuccess(resData?.data || resData);
      }
    })
    .catch((err) => {
      if (onError) {
        onError(err);
      }
    });
};

/**
 * Mark a feature request as done
 * @param {*} options
 */
export const markFeatureRequestDone = (options) => async (dispatch) => {
  const { data, onSuccess, onError } = options || {};
  axios
    .post("/super-admin/feature-requests/mark-done", data)
    .then((res) => {
      if (onSuccess) {
        const { data: resData } = res || {};
        onSuccess(resData?.data || resData);
      }
    })
    .catch((err) => {
      if (onError) {
        onError(err);
      }
    });
};

/**
 * Move a completed feature request back to inbox
 * @param {*} options
 */
export const reopenFeatureRequest = (options) => async (dispatch) => {
  const { data, onSuccess, onError } = options || {};
  axios
    .post("/super-admin/feature-requests/reopen", data)
    .then((res) => {
      if (onSuccess) {
        const { data: resData } = res || {};
        onSuccess(resData?.data || resData);
      }
    })
    .catch((err) => {
      if (onError) {
        onError(err);
      }
    });
};

/**
 * Permanently delete a feature request
 * @param {*} options
 */
export const deleteFeatureRequest = (options) => async (dispatch) => {
  const { data, onSuccess, onError } = options || {};
  axios
    .post("/super-admin/feature-requests/delete", data)
    .then((res) => {
      if (onSuccess) {
        const { data: resData } = res || {};
        onSuccess(resData?.data || resData);
      }
    })
    .catch((err) => {
      if (onError) {
        onError(err);
      }
    });
};
